export { Switch } from "@mantine/core";
export type { SwitchProps, SwitchGroupProps } from "@mantine/core";
export { switchOverrides } from "./Switch.config";
